var _circle, _path, _path2, _circle2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#2D3F5C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3024 48.0009V29.1689L40.9824 31.8089V27.5529L45.3024 24.9609H49.2384V48.0009H45.3024Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5282 48.4805C26.8962 48.4805 25.4562 48.1338 24.2082 47.4405C22.9602 46.7365 21.9842 45.7605 21.2802 44.5125C20.5869 43.2645 20.2402 41.8245 20.2402 40.1925V32.7685C20.2402 31.1365 20.5869 29.6965 21.2802 28.4485C21.9842 27.2005 22.9602 26.2298 24.2082 25.5365C25.4562 24.8325 26.8962 24.4805 28.5282 24.4805C30.1602 24.4805 31.5949 24.8325 32.8322 25.5365C34.0802 26.2298 35.0562 27.2005 35.7602 28.4485C36.4642 29.6965 36.8162 31.1365 36.8162 32.7685V40.1925C36.8162 41.8245 36.4642 43.2645 35.7602 44.5125C35.0562 45.7605 34.0802 46.7365 32.8322 47.4405C31.5949 48.1338 30.1602 48.4805 28.5282 48.4805ZM28.5282 44.8165C29.3389 44.8165 30.0749 44.6245 30.7362 44.2405C31.3976 43.8458 31.9202 43.3231 32.3042 42.6725C32.6882 42.0111 32.8802 41.2751 32.8802 40.4645V32.4805C32.8802 31.6591 32.6882 30.9231 32.3042 30.2725C31.9202 29.6111 31.3976 29.0885 30.7362 28.7045C30.0749 28.3098 29.3389 28.1125 28.5282 28.1125C27.7176 28.1125 26.9816 28.3098 26.3202 28.7045C25.6589 29.0885 25.1362 29.6111 24.7522 30.2725C24.3682 30.9231 24.1762 31.6591 24.1762 32.4805V40.4645C24.1762 41.2751 24.3682 42.0111 24.7522 42.6725C25.1362 43.3231 25.6589 43.8458 26.3202 44.2405C26.9816 44.6245 27.7176 44.8165 28.5282 44.8165Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3856_1765",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#661CE7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3856_1765)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 72,
    r: 21,
    fill: "white",
    fillOpacity: 0.24
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/Step1.1fbd7e1947f8b3b8cc469e51ceadbab8.svg";
export { ForwardRef as ReactComponent };